import { useQuery } from "@tanstack/react-query";
import { useAtom, useSetAtom } from "jotai";

import { AuthApi } from "@/config/apiClient";
import { createApiClient } from "@/config/createApiClient";
import { accessTokenAtom, refreshTokenAtom } from "@/store/atoms/authTokens";

export const useAuth = () => {
  const [accessToken, setAccessToken] = useAtom(accessTokenAtom);
  const setRefreshToken = useSetAtom(refreshTokenAtom);

  const isAuthenticated = !!accessToken;

  const apiClient = createApiClient(AuthApi);

  const useGetUser = () =>
    useQuery({
      enabled: isAuthenticated,
      queryKey: ["get-me", accessToken],
      queryFn: async () => {
        const response = await apiClient.authControllerMe();
        if (response.status === 200) {
          return response.data;
        }
      },
    });

  const disconnect = () => {
    setAccessToken("");
    setRefreshToken("");
  };

  return {
    isAuthenticated,
    disconnect,
    useGetUser,
  };
};
